import { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { Routes } from '@share/constants';
import {
  FunctionalRootState,
  isPublicClubSiteAnonymousVisitor,
  isPublicClubSiteBookingLandingPath,
  isCertificatePathFromLocation,
} from '@share/utils';

export function PublicClubSiteLandingRedirect(): null {
  const history = useHistory();
  const location = useLocation();
  const account = useSelector((state: FunctionalRootState) => state.loginStore.account);
  const loading = useSelector((state: FunctionalRootState) => state.loginStore.loading);

  useEffect(() => {
    if (loading || !account || !isPublicClubSiteAnonymousVisitor(account)) {
      return;
    }

    if (isCertificatePathFromLocation(location.pathname)) {
      return;
    }

    if (!isPublicClubSiteBookingLandingPath(location.pathname)) {
      return;
    }

    history.replace(`/${account.name}${Routes.CertificatesCatalog}`);
  }, [account, history, loading, location.pathname]);

  return null;
}
